<template>
  <b-modal 
    id="modal-filter" 
    centered 
    hide-footer 
    title="Filters"
    size="lg">
    <div class="row">
      <!-- Training Scope -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Training Scope</label>
        <v-select
          v-model="filters.training_scope"
          :options="trainingScopeOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Training Scope">
        </v-select>
      </div>

      <!-- Platform -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Platform</label>
        <v-select
          v-model="filters.platform"
          :options="platformOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Platform">
        </v-select>
      </div>

      <!-- Role Competency -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Role Competency</label>
        <v-select
          v-model="filters.role_competency_id"
          :options="roleOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Role Competency"
          :loading="isLoadingRoleCompetency">
        </v-select>
      </div>

      <!-- Competency Type -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Competency Type</label>
        <v-select
          v-model="filters.competency_type"
          :options="competencyTypeOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Competency Type">
        </v-select>
      </div>

      <!-- Competency -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Competency</label>
        <v-select
          v-model="filters.competency_id"
          :options="competencyOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Competency"
          :loading="isLoadingCompetency">
        </v-select>
      </div>
    </div>

    <!-- Modal Footer with Buttons -->
    <div class="d-flex justify-content-end gap-3 mt-4">
      <button
        type="button"
        class="btn btn-outline-danger"
        @click="resetFilters">
        Reset filters
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="applyFilters">
        Apply filters
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ModalFilter',
  data() {
    return {
      trainingScopeOptions: [
        { value: 'BIB-HO', label: 'BIB-HO' },
        { value: 'BIB-Site', label: 'BIB-Site' },
        { value: 'BIB-Partner', label: 'BIB-Partner' }
      ],
      platformOptions: [
        { value: 'My Learning', label: 'My Learning' },
        { value: 'Ugems University', label: 'BIB Academy' },
        { value: 'Other', label: 'Other' }
      ],
      competencyTypeOptions: [
        { value: 'Thematic', label: 'Thematic' },
        { value: 'Internal', label: 'Internal' },
        { value: 'External', label: 'External' }
      ],
      filters: {
        training_scope: null,
        platform: null,
        role_competency_id: null,
        competency_type: null,
        competency_id: null
      }
    }
  },
  computed: {
    ...mapGetters('modalFilter', {
      roleOptions: 'getRoleCompetencyOptions',
      competencyOptions: 'getCompetencyOptions',
      isLoadingRoleCompetency: 'getLoadingRoleCompetency',
      isLoadingCompetency: 'getLoadingCompetency'
    }),
  },
  mounted() {
    // Load filter options when component is mounted
    this.loadRoleCompetencyOptions();
    this.loadCompetencyOptions();
  },
  methods: {
    ...mapActions('modalFilter', ['loadRoleCompetencyOptions', 'loadCompetencyOptions']),
    resetFilters() {
      this.filters = {
        training_scope: null,
        platform: null,
        role_competency_id: null,
        competency_type: null,
        competency_id: null
      };
      this.$emit('reset-filters');
    },

    applyFilters() {
      // Convert null to empty string for API
      const filtersToApply = {
        training_scope: this.filters.training_scope || "",
        platform: this.filters.platform || "",
        role_competency_id: this.filters.role_competency_id || "",
        competency_type: this.filters.competency_type || "",
        competency_id: this.filters.competency_id || ""
      };
      this.$emit('apply-filters', filtersToApply);
    }
  }
}
</script>

<style scoped>
/* Add any specific styles if needed */
</style>
